import { useState, useEffect } from "react";

import { apiRoot } from "../constants";

const useCity = (title) => {
  const [city, setCity] = useState(null);
  const [dishes, setDishes] = useState([]);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dishesLoading, setDishesLoading] = useState(false);
  const [eventsLoading, setEventsLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${apiRoot}/cities/by_title?title=${title}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setCity(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setCity();
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setCity();
        setLoading(false);
      });
  }, [title]);

  useEffect(() => {
    setDishesLoading(true);

    const url = `/dishes?city_title=${title}`;
    fetch(`${apiRoot}${url}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setDishes(json);
            setError(false);
            setDishesLoading(false);
          });
        } else {
          setError(true);
          setDishes([]);
          setDishesLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setDishes([]);
        setDishesLoading(false);
      });
  }, [title]);

  useEffect(() => {
    setEventsLoading(true);

    const url = `/events?city_title=${title}`;
    fetch(`${apiRoot}${url}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setEvents(json);
            setError(false);
            setEventsLoading(false);
          });
        } else {
          setError(true);
          setEvents([]);
          setEventsLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setEvents([]);
        setEventsLoading(false);
      });
  }, [title]);

  return {
    city,
    dishes,
    events,
    error,
    loading,
    dishesLoading,
    eventsLoading,
  };
};

export default useCity;
